// Lib
import React from 'react';
import { Flex } from 'rebass';

// Constants
import { RECRUITER, EMPLOYER } from 'constants/index';

// Types
import { UserRoleType } from 'types/global';

// Components
import JobBoardStage from './JobBordStage';
import EmptyCandidates, { EmptyRecruiter } from './EmptyCandidates';

// Hooks
import useJobBoardCandidates from '../hooks/useJobBoardCandidates';

interface JobBoardProps {
  userRole: UserRoleType;
  jobPostId: number;
}

const JobBoard: React.FC<JobBoardProps> = ({ userRole, jobPostId }): JSX.Element => {
  const { stages, loading, isContainCandidates }: any = useJobBoardCandidates(jobPostId);

  return (
    <>
      <Flex width="100%" justifyContent="space-between" mt={7}>
        {stages.map((stage: any) => (
          <JobBoardStage
            key={stage.id}
            title={stage.title}
            userRole={userRole}
            candidates={stage.candidates}
            borderLess={!isContainCandidates}
          />
        ))}
      </Flex>
      <EmptyCandidates visible={!isContainCandidates && !loading && userRole === EMPLOYER}>
        Nothing here just yet.
        <br />
        Check back soon!
      </EmptyCandidates>
      <EmptyCandidates visible={!isContainCandidates && !loading && userRole === RECRUITER}>
        <EmptyRecruiter jobId={jobPostId} />
      </EmptyCandidates>
    </>
  );
};

export default JobBoard;
